import Swiper from 'swiper/bundle';

window.theme.block('galeria-fotos', el => {
    const galeria = el.querySelector('.js-galeria');

    if (galeria) {
        new Swiper(galeria, {
            slidesPerView: 'auto',
            loop: true,
            autoHeight: true,
            speed: 0,
            navigation: {
                prevEl: el.querySelector('.js-prev'),
                nextEl: el.querySelector('.js-next')
            },
        });
    }
});